<script>
import Endpoints from '../../../components/common/Endpoints';
import Common from '../../../components/common/Common';
import Request from '../../../components/common/Request';
import { mapActions } from 'vuex'

let type = "TRUCKER";


export default {
   
 
        init: () => {
        const el = document.body;
        el.removeAttribute("class");
        $('.modal').modal('hide');
        
        },
        methods:{
        Approve: function(){
            $('#spinner').modal('toggle');
            this.errors = [];
            this.messageIdToast = null;
            let state = this;
            Request.do(this, 'PUT', Request.getDefaultHeader(this), this.data, `${Endpoints.systemUsers.systemUser}${this.data.email}`,
                (response)=>{//SUCCESS CALLBACK
                    state.data._id = response.result._id;
                    state.valuekey += 1;
                    $('#spinner').modal('toggle');
                },
                (error)=>{//ERROR CALLBACK
                    $('#spinner').modal('toggle');
                    let res = error.response;
                    if (res && res.status){
                        this.titleToast = this.$t("string.msg.warning");
                        
                        if (res.data.messageId === 'response.msg.error.empty.fields'){
                            let fields = "";
                            res.data.errors.forEach(function (value) {
                                fields += state.$t(value.id)+";<br/>";
                            });
                            this.titleToast = this.$t(res.data.messageId);
                            this.messageToast = this.$t(fields);
                        }else{
                            this.messageToast = this.$t(res.data.messageId);
                            this.messageIdToast = res.data.messageId;
                        }

                        $('#toast').modal('show');
                    }
                    console.log(JSON.stringify(error));
            });
        },
         selectItem: function(item){
            this.data = JSON.parse(JSON.stringify(item));
            this.data.firstName = Common.camelize(this.data.firstName);
            this.data.lastName = Common.camelize(this.data.lastName);

            document.body.scrollTop = 0; // For Safari
            document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera

        },
        archive: function(response){
            if (response==1){
                $('#spinner').modal('toggle');
                this.errors = [];
                this.messageIdToast = null;
                let state = this;
                // this.data.document = this.data.document.replace(/\//g, '').replace(/\./g, '').replace(/\-/g, '');
                Request.do(this, 'DELETE', Request.getDefaultHeader(this), this.data, `${Endpoints.systemUsers.systemUser}${this.data.email}`,
                    (companyResponse)=>{//SUCCESS CALLBACK

                        $('#spinner').modal('toggle');
                    },
                    (error)=>{//ERROR CALLBACK
                        $('#spinner').modal('toggle');
                        let res = error.response;
                        if (res && res.status){
                            this.titleToast = this.$t("string.msg.warning");
                            if (res.data.messageId === 'response.msg.error.empty.fields'){
                                let fields = "";
                                res.data.errors.forEach(function (value) {
                                    fields += state.$t(value.id)+";<br/>";
                                });
                                this.titleToast = this.$t(res.data.messageId);
                                this.messageToast = this.$t(fields);
                            }else{
                                this.messageToast = this.$t(res.data.messageId);
                                this.messageIdToast = res.data.messageId;
                            }

                            $('#toast').modal('show');
                        }
                        console.log(JSON.stringify(error));
                });
            }
        },
         confirmArchive: function(item){
            this.titleToast = this.$t("string.msg.confirm");
            this.messageToast = this.$t("response.approve.trucker.confirmation");
            this.cancelText = this.$t("string.msg.cancel");
            this.yesText = this.$t("string.msg.yes");
            $('#confirmationModal').modal('show');
        },
        clearForm: function(){
            this.data = {};
            this.data.customerUser={};
        },
   
         camelize: Common.camelize,
         toUpperCase: Common.toUpperCase,
    }
}
</script>
